import * as React from "react";
import { SVGProps, memo } from "react";

const BxBxBarcode = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20 4H4C2.897 4 2 4.897 2 6V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V6C22 4.897 21.103 4 20 4ZM4 18V6H20L20.001 18H4Z" fill="currentColor" /><path d="M6 8H8V16H6V8ZM9 8H10V16H9V8ZM17 8H18V16H17V8ZM13 8H16V16H13V8ZM11 8H12V16H11V8Z" fill="currentColor" /></svg>;

const Memo = memo(BxBxBarcode);
export default Memo;